import React, { useRef, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
    Checkbox,
    Divider,
    FormControl,
    InputLabel,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
    Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { requestedCompaniesSliceSelectors, updateFilter } from "../../../../slices/Stacks/requestedCompaniesSlice";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: "100%",
    },
    indeterminateColor: {
        "& .MuiSvgIcon-root": {
            color: `${theme.palette.secondary[500]} !important`,
        },
    },
    menuPaper: {
        ...theme.components.MuiFormControl.variants[0].FilterMenuStyle,
    },
}));

const options = [
    { name: "In Progress", id: "in_progress" },
    { name: "Done", id: "done" },
];

const delayTime = 500;
function StatusField() {
    const filter = useSelector(requestedCompaniesSliceSelectors.getFilter);
    const selectedStatuses = filter?.status.map((status) => status.id) || [];
    const isAllSelected = options.length > 0 && selectedStatuses.length === options.length;
    const elementRef = useRef(null);
    const dispatch = useDispatch();
    const classes = useStyles();

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            },
        },
        classes: { paper: classes.menuPaper },
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center",
        },
        variant: "menu",
    };

    const handleChange = (event) => {
        const { value } = event.target;

        if (value[value.length - 1] === "all") {
            dispatch(
                updateFilter({
                    ...filter,
                    status: selectedStatuses.length === options.length ? [] : options,
                }),
            );
            return;
        }
        let duplicateRemoved = [];

        value.forEach((item) => {
            if (duplicateRemoved.findIndex((elem) => elem.id === item.id) >= 0) {
                duplicateRemoved = duplicateRemoved.filter((x) => x.id !== item.id);
            } else {
                duplicateRemoved.push(options.find((status) => status.id === item));
            }
        });

        dispatch(updateFilter({ ...filter, status: duplicateRemoved }));
    };

    useEffect(() => {
        MenuProps.PaperProps.style.width = elementRef.current.getBoundingClientRect().width;
    }, []);

    return (
        <Tooltip
            enterNextDelay={delayTime}
            title="Choose status to filter down the requested companies."
            placement="top"
        >
            <FormControl
                ref={elementRef}
                id="status-form-control"
                variant="outlined"
                size="small"
                className={classes.formControl}
            >
                <InputLabel>Status</InputLabel>
                <Select
                    multiple
                    value={selectedStatuses}
                    onChange={handleChange}
                    renderValue={(selectedItems) =>
                        selectedItems.map((item) => options.find((status) => status.id === item)?.name).join(", ")
                    }
                    color="secondary"
                    MenuProps={MenuProps}
                    label="Status"
                >
                    <MenuItem value="all">
                        <ListItemIcon>
                            <Checkbox
                                classes={{
                                    indeterminate: classes.indeterminateColor,
                                    checked: classes.indeterminateColor,
                                }}
                                checked={isAllSelected}
                                indeterminate={selectedStatuses.length > 0 && selectedStatuses.length < options.length}
                            />
                        </ListItemIcon>
                        <ListItemText primary="Select all" />
                    </MenuItem>
                    <Divider />
                    {options.length > 0 &&
                        options.map((status) => (
                            <MenuItem key={status.id} value={status.id}>
                                <ListItemIcon>
                                    <Checkbox checked={selectedStatuses.includes(status.id)} />
                                </ListItemIcon>
                                <ListItemText primary={status.name} />
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </Tooltip>
    );
}

export default StatusField;
